'use strict';

/* jscs:disable validateNewlineAfterArrayElements */
angular.module('AcaApp').factory('ImportService',
[
  'ImportResource',
  '$q',
  'LRJ_MANAGER',
  function(ImportResource, $q, LRJ_MANAGER){
    return{
      importTest: function(mapName, fileName, fileType, fcharParticipant, fcharForm, fcharEmployer){
        var rpcConfig = {method: 'importTest', params: [mapName, 'TEST', fileName, fileType, fcharParticipant, fcharForm, fcharEmployer]};
        return ImportResource.executeRpc(rpcConfig).$promise;
      },
      importLrj: function(mapName, fileName, fileType, fcharParticipant, fcharForm, fcharEmployer){
        var rpcConfig = {method: 'CallImportLrj', params: [mapName, 'NoEst', fileName, fileType, fcharParticipant, fcharForm, fcharEmployer]};
        return ImportResource.executeRpc(rpcConfig).$promise;
      },
      importResults: function(imports, fileName, fchar){
        var rpcConfig = {method: 'ImportResults', params: [imports, fileName, fchar]};
        return ImportResource.executeRpc(rpcConfig).$promise;
      },
      getStoredMapNames: function(){
        var rpcConfig = {method: 'getMaps', params: []};
        return ImportResource.executeRpc(rpcConfig).$promise;
      },
      getMapParams: function(mapFullName, mapName){
        var rpcConfig = {method: 'getMapParams', params: [mapFullName, mapName]};
        return ImportResource.executeRpc(rpcConfig).$promise;
      },
      getImportSample: function(fileName, fileType, fchar){
        var rpcConfig = {method: 'getImportSample', params: [fileName, fileType, fchar]};
        return ImportResource.executeRpc(rpcConfig).$promise;
      },
      getMapSetting: function(mapFullName, mapName){
        return this.getMapParams(mapFullName, mapName).then(function(data){
          return angular.fromJson(data.result.value);
        });
      },
      getMap: function(fileName){
        var rpcConfig = {method: 'getMap', params: [fileName]};
        return ImportResource.executeRpc(rpcConfig).$promise;
      },
      getMapValue: function(fileName){
        return this.getMap(fileName).then(function(data){
          return angular.fromJson(data.result.value);
        });
      },
      import1094: function(mapName, fileName, fileType){
        var rpcConfig = {method: 'import1094', params: [mapName, fileName, fileType]};
        return ImportResource.executeRpc(rpcConfig).$promise;
      }
    };
  }
]);